// src/pages/AboutPage.jsx
import { useState } from "react";
import Carousel from "../components/Carousel"; 
import "../index.css";

const PHOTOS = [
  {src: "/Story2.png", title: "Humble Beginnings", blurb: "Our family’s story began in a small town in Taishan, China. Food was more than a meal it brought family together. Those values would eventually travel with our family across the world."}, 
  { src: "/Story1.jpeg", title: "Late Night Dinners", blurb: "Around this table, laughter mixed the warmth of shared dishes. Night after night, these meals became more than food they became the threads that brought us closer together." },
  { src: "/Story3.png", title: "Changing", blurb: "Over time, Lucky Chopsticks continued to grow and change, carrying forward the traditions, memories, and sense of community that had always been part of the restaurant." },
  { src: "/Story4.png", title: "Our Family Today", blurb: "Today, Lucky Chopsticks is part of our family’s story. We’ve made it our own while carrying forward the values of family, hard work, and sharing good food with our community." },
];

function Parchment({ children, className = "" }) {
  return (
    <div className={`parchment ${className}`}>
      <div className="parchment-cap top" />
      <div className="parchment-cap bot" />
      {children}
    </div>
  );
}


function PhotoStory({ src, title, blurb }) {
  const [open, setOpen] = useState(false);
  return (
    <article className={`story-card ${open ? "open" : ""}`}>
      <button className="story-btn" onClick={() => setOpen(!open)} aria-expanded={open}>
        <img className="story-img" src={src} alt={title} />
        <div className="story-chip">
          <h4 className="story-title">{title}</h4>
          <span className={`chev ${open ? "rot" : ""}`}>▾</span>
        </div>
      </button>
      <div className="story-reveal">
        <p className="muted">{blurb}</p>
      </div>
    </article>
  );
}

export default function AboutPage() {
  return (
    <main className="AboutPage">
        {/* Hero */}
        <section className="about-hero">
            <div className="hero-wrapper">
                <Carousel
                images={["/History1.jpeg"]}
                interval={4000}
                autoplay
                loop
                showDots
                showArrows = {false}
                />

                {/* Overlay + text stacked on top of carousel */}
                <div className="about-hero-overlay" />
                <div className="about-hero-inner">
                <h1>Our Story</h1>
                <p>
                    Lucky Chopsticks began with a wok and a promise: simple, honest flavors
                    that taste like home.
                </p>
                </div>
            </div>
        </section>

    


      {/* Intro blocks */}
      <section className="container section">
        <div className="grid-2-1">
          <Parchment className="stack">
            <div className="row gap">
              <div>
                <h3 className="title">Made for family, shared with neighbors</h3>
                <p className="muted">
                  We grew up around bustling tables and late-night bowls. Our menu is a love letter to those moments, one plate at a time.
                </p>
              </div>
            </div>
          </Parchment>
          <Parchment>
            <h4 className="title sm">Hours</h4>
            <p className="muted">Tue-Thurs: 11:30–8:00  •  Fri–Sat: 11:30–8:30  •  Mon: Closed</p>
          </Parchment>
        </div>
      </section>

      {/* Photo stories grid */}
      <section className="container section">
        <h2 className="h2">Little Stories</h2>
        <div className="photo-grid">
          {PHOTOS.map((p) => (
            <PhotoStory key={p.src} {...p} />
          ))}
        </div>
      </section>

      {/* Milestones */}
      <section className="container section">
        <h2 className="h2">Milestones</h2>
        <div className="timeline">
          <ul className="timeline-list">
            {[
              { y: "2001", t: "Opening" },
              { y: "2006", t: "Serving the Community" },
              { y: "2017", t: "Retirement and New Beginnings" },
              { y: "Now", t: "Still Serving the Same Great Flavors" },
            ].map((i) => (
              <li key={i.y} className="timeline-item">
                <span className="dot" />
                <Parchment>
                  <div className="row between">
                    <span className="muted strong">{i.y}</span>
                    <span className="strong">{i.t}</span>
                  </div>
                </Parchment>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
}
